module.exports = __webpack_public_path__ + "paypal-logo.63eef2fdc9cc4a17cbe3377bb5d45a1f.png";